import React, { useState } from "react";
import { Heart } from "lucide-react";
import { api } from "@/lib/api";

export const cid = () => {
  let c = localStorage.getItem("sc_cid");
  if (!c) { c = (crypto as any).randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`; localStorage.setItem("sc_cid", c as string); }
  return c as string;
};
const likedSet = (): string[] => JSON.parse(localStorage.getItem("sc_liked_posts") || "[]");

export function LikeButton({ slug, likes = 0, size = "md" }: { slug: string; likes?: number; size?: "sm" | "md" }) {
  const [s, setS] = useState({ likes, liked: likedSet().includes(slug) });
  const save = (liked: boolean) => localStorage.setItem("sc_liked_posts", JSON.stringify(liked ? [...new Set([...likedSet(), slug])] : likedSet().filter((x) => x !== slug)));
  const toggle = async () => {
    const prev = s;
    setS({ likes: Math.max(0, s.likes + (s.liked ? -1 : 1)), liked: !s.liked });
    try { const r = await api.post(`/blog/${slug}/like`, { cid: cid() }); setS(r.data); save(r.data.liked); }
    catch { setS(prev); }
  };
  const sm = size === "sm";
  return (
    <button type="button" onClick={toggle} aria-pressed={s.liked} aria-label={`${s.liked ? "Unlike" : "Like"} this article, ${s.likes} ${s.likes === 1 ? "like" : "likes"}`}
      className={`group/like inline-flex items-center gap-1.5 ${sm ? "text-xs" : "text-sm"} text-neutral-700 hover:text-[var(--c-primary)] transition-colors`} data-testid={`like-button-${slug}`}>
      <Heart size={sm ? 15 : 18} strokeWidth={1.4} className={`transition-transform duration-300 group-active/like:scale-125 ${s.liked ? "fill-[var(--c-primary)] text-[var(--c-primary)]" : ""}`} />
      <span data-testid={`like-count-${slug}`}>{s.likes}</span>
    </button>
  );
}
